import { publicGreenAreas } from "@/mocks/publico";
import { PublicStatusBadge } from "./PublicBadges";

export default function PublicGreenAreasSection() {
  return (
    <section id="areas-verdes" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">Áreas Verdes e Unidades de Conservação</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Conheça as praças, parques, áreas verdes, APPs urbanas e Unidades de Conservação com inventário arbóreo cadastrado.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {publicGreenAreas.map((area) => (
            <div
              key={area.id}
              className="bg-white rounded-xl p-5 border border-background-200/70 hover:border-background-300/60 transition-colors"
            >
              {/* Header */}
              <div className="flex items-start gap-3 mb-3">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${
                  area.tipo === "Parque" ? "bg-primary-50" :
                  area.tipo === "Praça" ? "bg-accent-50" :
                  area.tipo === "Unidade de Conservação" ? "bg-accent-50" :
                  area.tipo === "APP Urbana" ? "bg-warning-50" :
                  "bg-secondary-50"
                }`}>
                  <i className={`${
                    area.tipo === "Parque" ? "ri-tree-line text-primary-600" :
                    area.tipo === "Praça" ? "ri-building-2-line text-accent-600" :
                    area.tipo === "Unidade de Conservação" ? "ri-shield-star-line text-accent-600" :
                    area.tipo === "APP Urbana" ? "ri-drop-line text-warning-600" :
                    "ri-landscape-line text-secondary-600"
                  } text-lg w-5 h-5 flex items-center justify-center`} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 leading-snug">{area.nome}</h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{area.tipo} · {area.bairro}</p>
                </div>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-2 gap-3 mb-3">
                <div className="bg-background-50 rounded-lg p-2.5">
                  <span className="text-xs text-foreground-400">Área</span>
                  <p className="text-sm font-semibold text-foreground-900">{area.areaHa} ha</p>
                </div>
                <div className="bg-background-50 rounded-lg p-2.5">
                  <span className="text-xs text-foreground-400">Árvores</span>
                  <p className="text-sm font-semibold text-foreground-900">{area.arvores}</p>
                </div>
                <div className="bg-background-50 rounded-lg p-2.5">
                  <span className="text-xs text-foreground-400">Espécies</span>
                  <p className="text-sm font-semibold text-foreground-900">{area.especies}</p>
                </div>
                <div className="bg-background-50 rounded-lg p-2.5">
                  <span className="text-xs text-foreground-400">Status</span>
                  <div className="mt-0.5">
                    <PublicStatusBadge status={area.status} />
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-400">Última vistoria: {area.ultimaVistoria}</span>
                <button className="text-xs font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer">
                  Ver no mapa <i className="ri-map-pin-line w-3 h-3 inline-flex items-center justify-center ml-0.5" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}